import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles((theme) => ({
  root: {
    padding: '2px 4px',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  iconButton: {
    display: 'flex',
    alignItems: 'center',
    padding: 10,
    color: '#c4302b',
  },
  divider: {
    height: 28,
    margin: 4,
  },
}));


export default useStyles